import React from 'react';
export function SEOHead() {
  const siteTitle = 'Keyanalyzer - Discover the Best Tools for Every Task';
  const siteDescription = 'Find the perfect software solutions for your needs. Compare top-rated tools, read reviews, and make better decisions with Keyanalyzer.';
  const siteUrl = 'https://keyanalyzer.com';
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Keyanalyzer',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Keyanalyzer',
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    sameAs: ['https://twitter.com/keyanalyzer', 'https://linkedin.com/company/keyanalyzer', 'https://facebook.com/keyanalyzer']
  };
  return <>
      {/* Note: In a real app, these would be injected into <head> via react-helmet or Next.js Head */}
      <div className="hidden" data-id="element-137">
        <title data-id="element-138">{siteTitle}</title>
        <meta name="description" content={siteDescription} data-id="element-139" />
        <meta property="og:title" content={siteTitle} data-id="element-140" />
        <meta property="og:description" content={siteDescription} data-id="element-141" />
        <meta property="og:image" content={`${siteUrl}/og-image.jpg`} data-id="element-142" />
        <meta property="og:url" content={siteUrl} data-id="element-143" />
        <meta property="og:type" content="website" data-id="element-144" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-145" />
        <meta name="twitter:title" content={siteTitle} data-id="element-146" />
        <meta name="twitter:description" content={siteDescription} data-id="element-147" />

        <script type="application/ld+json" data-id="element-148">
          {JSON.stringify(websiteSchema)}
        </script>
        <script type="application/ld+json" data-id="element-149">
          {JSON.stringify(organizationSchema)}
        </script>
      </div>
    </>;
}